<template>
  <div class="app-container">
    <div class="filter-container" style="margin-bottom: 25px">
      <el-row :gutter="20">
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="title">总入账(美元)</div>
            <div class="value">
              {{sum.total_price}}
            </div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="title">SOL入账</div>
            <div class="value">
              {{sum.sol_amount}}
            </div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="title">USDT入账</div>
            <div class="value">
              {{sum.usdt_amount}}
            </div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="title">TON入账</div>
            <div class="value">
              {{sum.ton_amount}}
            </div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="title">KAIA入账</div>
            <div class="value">
              {{sum.kaia_amount}}
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="filter-container">
      <el-input
        v-model="listQuery.user_address"
        placeholder="地址"
        style="width: 320px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      size="large"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="用户地址" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_address }}
        </template>
      </el-table-column>

      <el-table-column label="SOL收款钱包" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.system_wallet }}
        </template>
      </el-table-column>
      <el-table-column label="TON收款钱包" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.tg_system_wallet }}
        </template>
      </el-table-column>
      <el-table-column label="短剧名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.video?scope.row.video.video_title:"-" }}
        </template>
      </el-table-column>

      <el-table-column label="解锁集数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.episode_num }}
        </template>
      </el-table-column>

      <el-table-column label="单价" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.unit_price }}
        </template>
      </el-table-column>

      <el-table-column label="总价" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_price }}
        </template>
      </el-table-column>

      <el-table-column label="付款" min-width="120" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.pay_method === 'sol'">{{ Number(scope.row.sol_amount) }} SOL</span>
          <span v-if="scope.row.pay_method === 'usdt'">{{ Number(scope.row.usdt_amount) }} USDT</span>
          <span v-if="scope.row.pay_method === 'ton'">{{ Number(scope.row.ton_amount) }} TON</span>
          <span v-if="scope.row.pay_method === 'kaia'">{{ Number(scope.row.kaia_amount) }} KAIA</span>
        </template>
      </el-table-column>

      <el-table-column label="公链" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.chain }}
        </template>
      </el-table-column>

      <el-table-column label="交易" min-width="120" align="center">
        <template slot-scope="scope">
          <span style="font-size: 12px;">{{ scope.row.tx_hash }}</span>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
      },
      sum:{
        total_price:0,
        usdt_amount:0,
        sol_amount:0,
        ton_amount:0,
      },
      dialogFormVisible: false,
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/video/video-orders",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.list
        this.total = response.data.total;
        this.sum = response.data.sums;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.balance {
  font-size: 18px;
  font-weight: bold;
}
.box-card {
  text-align: center;
  .value {
    font-size: 26px;
    margin-top: 20px;
    color: gray;
  }
  .title {
    font-size: 20px;
    color: black;
    font-weight: bold;
  }
  .subtitle {
    font-size: 12px;
    color: gray;
  }
}
</style>
